const megaMenuDropDowns = document.querySelectorAll('.js-mega-menu > li > .dropdown-menu');

const megamenu = {
  showDropDowns() {
    console.log('showDropDowns');
    megaMenuDropDowns.forEach((dropdown) => {
      dropdown.classList.add('show');
    });
  },
  hideDropDowns() {
    megaMenuDropDowns.forEach((dropdown) => {
      dropdown.classList.remove('show');
    });
  },
  setDropDowns() {
    if (window.innerWidth >= 1025) {
      megamenu.showDropDowns();
    }
    else {
      megamenu.hideDropDowns();
    }
  },
  init() {
    // For some odd reason, Firefox doesn't fire
    // if setDropDowns() is called via on load event
    // so it needs a direct call on page load
    megamenu.setDropDowns();
    $(window).on('resize', function () {
      megamenu.setDropDowns();
    });

    $('.nav > .menu-item-has-children > .nav-link').on('click', function(e) {
      if (window.matchMedia('(max-width: 1024px)').matches) {
        e.preventDefault();
        $(this).siblings('.dropdown-menu').toggleClass('show');
        $(this).parent().toggleClass('show');
      }
    });
  },
};

export default megamenu;



// WEBPACK FOOTER //
// ./scripts/modules/megamenu.js